import React from 'react';
import { Link } from 'react-router-dom';
import appConfig from '../../config/appConfig';
import SEO from '../../components/SEO';
import { GrievanceBlock } from '../../components/legal/LegalBaseline';

// Dedicated grievance / data-protection contact page, published per India's IT
// intermediary rules and the DPDP Act. Content comes from appConfig.legal.
const Grievance = () => (
  <div className="min-h-screen bg-gray-50">
    <SEO title="Grievance Officer" description={`Grievance and data-protection contact for ${appConfig.name}.`} path="/grievance" />
    <div className="bg-white border-b border-gray-200">
      <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/browse" className="text-xl font-bold text-blue-600">{appConfig.name}</Link>
        <div className="flex gap-4 text-sm">
          <Link to="/terms" className="text-gray-600 hover:text-blue-600">Terms</Link>
          <Link to="/privacy" className="text-gray-600 hover:text-blue-600">Privacy</Link>
          <Link to="/support" className="text-gray-600 hover:text-blue-600">Support</Link>
        </div>
      </div>
    </div>

    <div className="max-w-4xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold text-gray-900 mb-3">Grievance Officer</h1>
      <p className="text-gray-600 mb-2">
        If you have a complaint about any content, listing, transaction or your personal data on
        {' '}{appConfig.name}, please reach out to our Grievance &amp; Data Protection Officer below.
        We take every complaint seriously.
      </p>
      <GrievanceBlock />
    </div>

    <div className="border-t border-gray-200 bg-white mt-10">
      <div className="max-w-4xl mx-auto px-4 py-4 flex flex-wrap items-center justify-between gap-2 text-sm text-gray-500">
        <span>{appConfig.copyright}</span>
        <div className="flex gap-4">
          <Link to="/support" className="hover:text-blue-600">Support</Link>
          <Link to="/terms" className="hover:text-blue-600">Terms</Link>
          <Link to="/privacy" className="hover:text-blue-600">Privacy</Link>
          <Link to="/refund-policy" className="hover:text-blue-600">Refund Policy</Link>
        </div>
      </div>
    </div>
  </div>
);

export default Grievance;
